/* VSKLO cart page controller. Drawer remains owned by cart-components.js. */
(function () {
  const root = document.querySelector('#main-cart-items');
  if (!root) return;
  if (window.__VSKLO_CART_PAGE_CONTROLLER__) return;
  window.__VSKLO_CART_PAGE_CONTROLLER__ = true;

  function vskloCartRoute(path) {
    const rootRoute = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return String(rootRoute).replace(/\/$/, '') + '/' + String(path || '').replace(/^\/+/, '');
  }

  // Defensive lifecycle normalization for cart add-on dialogs. This also covers
  // section/Ajax markup created before the shared popup shell gained inert/hidden.
  root.querySelectorAll('[data-vsklo-cart-addon-popup]').forEach((popup) => {
    if (popup.classList.contains('is-active')) return;
    popup.classList.remove('is-active');
    popup.setAttribute('aria-hidden', 'true');
    popup.setAttribute('inert', '');
    popup.hidden = true;
  });
  if (window.VSKLOOverlayState) {
    window.VSKLOOverlayState.release('cart-addon');
  } else if (!document.querySelector('[data-vsklo-cart-addon-popup].is-active')) {
    document.documentElement.classList.remove('open-popup');
  }

  function vskloCartT(key, fallback, params) {
    let value = window.vskloStrings && window.vskloStrings.addons && window.vskloStrings.addons[key];
    if (!value || (typeof value === 'string' && value.indexOf('Translation missing') !== -1)) {
      value = fallback || '';
    }
    if (params && typeof value === 'string') {
      Object.keys(params).forEach((name) => {
        value = value.replace(new RegExp('\\{\\{\\s*' + name + '\\s*\\}\\}', 'g'), params[name]);
      });
    }
    return value;
  }




  function vskloCartMessage(message) {
    const text = String(message || '').trim();
    if (!text) return;

    const old = document.querySelector('[data-vsklo-cart-message]');
    if (old) old.remove();

    const box = document.createElement('div');
    box.setAttribute('data-vsklo-cart-message', 'true');
    box.setAttribute('role', 'status');
    box.className = 'vsklo-cart-message';
    box.textContent = text;
    document.body.appendChild(box);
    window.setTimeout(() => box.remove(), 5200);
  }


  let vskloClearCartConfirmPromise = null;

  function vskloCartText(scope, key, fallback) {
    const value = window.vskloStrings && window.vskloStrings[scope] && window.vskloStrings[scope][key];
    return value && String(value).indexOf('Translation missing') === -1 ? value : fallback;
  }

  function confirmClearCart() {
    if (vskloClearCartConfirmPromise) return vskloClearCartConfirmPromise;

    vskloClearCartConfirmPromise = new Promise((resolve) => {

      const previouslyFocused = document.activeElement;
      let settled = false;
      const overlay = document.createElement('div');
      overlay.dataset.vskloClearCartDialog = 'true';
      overlay.className = 'vsklo-clear-cart-dialog';
      overlay.innerHTML = `
        <div class="vsklo-clear-cart-dialog__panel" role="dialog" aria-modal="true" aria-labelledby="vsklo-clear-cart-title" aria-describedby="vsklo-clear-cart-description">
          <button type="button" class="vsklo-clear-cart-dialog__close" data-vsklo-dialog-cancel aria-label="${vskloCartText('cart', 'clearCartCancel', 'Скасувати')}"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 18L18 6M6 6L18 18"></path></svg></button>
          <h3 id="vsklo-clear-cart-title">${vskloCartText('cart', 'clearCartDialogTitle', 'Очистити кошик?')}</h3>
          <p id="vsklo-clear-cart-description">${vskloCartText('cart', 'clearCartConfirm', 'Усі товари та додаткові послуги буде видалено з кошика.')}</p>
          <div class="vsklo-clear-cart-dialog__actions">
            <button type="button" class="vsklo-clear-cart-dialog__cancel" data-vsklo-dialog-cancel>${vskloCartText('cart', 'clearCartCancel', 'Скасувати')}</button>
            <button type="button" class="vsklo-clear-cart-dialog__ok" data-vsklo-dialog-ok>${vskloCartText('cart', 'clearCartOk', 'Очистити кошик')}</button>
          </div>
        </div>
      `;

      function close(result) {
        if (settled) return;
        settled = true;
        document.removeEventListener('keydown', escHandler, true);
        overlay.remove();
        document.documentElement.classList.remove('vsklo-dialog-open');
        vskloClearCartConfirmPromise = null;
        if (previouslyFocused && previouslyFocused.isConnected && typeof previouslyFocused.focus === 'function') {
          try { previouslyFocused.focus({ preventScroll: true }); }
          catch (error) { previouslyFocused.focus(); }
        }
        resolve(Boolean(result));
      }

      overlay.addEventListener('click', (event) => {
        if (event.target === overlay || event.target.closest('[data-vsklo-dialog-cancel]')) close(false);
        if (event.target.closest('[data-vsklo-dialog-ok]')) close(true);
      });

      const escHandler = (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close(false);
          return;
        }
        if (event.key !== 'Tab') return;
        const actions = [...overlay.querySelectorAll('button:not([disabled])')];
        if (!actions.length) return;
        const first = actions[0];
        const last = actions[actions.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };
      document.addEventListener('keydown', escHandler, true);

      document.body.appendChild(overlay);
      document.documentElement.classList.add('vsklo-dialog-open');
      overlay.querySelector('.vsklo-clear-cart-dialog__cancel')?.focus({ preventScroll: true });
    });

    return vskloClearCartConfirmPromise;
  }

  async function clearWholeCart(button) {
    if (button?.classList.contains('is-loading')) return;
    if (!(await confirmClearCart())) return;
    cartCore.setClearing(true);
    root.setAttribute('aria-busy', 'true');
    button?.classList.add('is-loading');
    button?.setAttribute('aria-busy', 'true');

    let clearCommitted = false;
    let metadataCleared = false;

    try {
      await cartCore.discardAllPendingCartEdits();
      await cartMutation('clear-cart', async () => {
        const res = await fetch(vskloCartRoute('cart/clear.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!res.ok) throw new Error('Cart clear failed');
        clearCommitted = true;

        // Clearing note/attributes is idempotent. Retry once while we still own
        // the mutation queue so a transient metadata failure cannot be reported
        // as if the item clear itself failed.
        for (let attempt = 0; attempt < 2; attempt += 1) {
          try {
            const metaResponse = await fetch(
              vskloCartRoute('cart/update.js'),
              fetchConfigJson({ note: '', attributes: {} })
            );
            if (metaResponse.ok) {
              metadataCleared = true;
              break;
            }
          } catch (metadataError) {
            if (attempt === 1) {
              console.warn('VSKLO cart metadata cleanup failed after committed clear', metadataError);
            }
          }
        }
      });

      if (!metadataCleared) {
        console.warn('VSKLO cart items were cleared, but metadata cleanup was not confirmed');
      }

      try {
        await refreshCartPageSectionFromServer();
      } catch (refreshError) {
        console.warn('VSKLO cleared cart UI refresh failed; reloading authoritative state', refreshError);
        window.location.reload();
      }
    } catch (error) {
      console.error('VSKLO clear cart failed', error);

      if (clearCommitted) {
        // The destructive write already succeeded. Never tell the shopper the
        // cart is still intact and never retry cart/clear.js from this state.
        try {
          await refreshCartPageSectionFromServer();
        } catch (refreshError) {
          console.warn('VSKLO committed clear recovery refresh failed', refreshError);
          window.location.reload();
        }
      } else {
        vskloCartMessage(vskloCartText('cart', 'clearCartError', 'Не вдалося очистити кошик. Спробуйте ще раз.'));
      }
    } finally {
      cartCore.setClearing(false);
      root.removeAttribute('aria-busy');
      button?.classList.remove('is-loading');
      button?.removeAttribute('aria-busy');
    }
  }

  const cartRenderSync = window.VSKLOCartRenderSync;
  if (!cartRenderSync) {
    throw new Error('[VSKLO] cart render-sync runtime is missing');
  }

  const formatMoney = cartRenderSync.formatMoney;

  function optimisticUpdateQtyTotals(qtyBox, previousQty, nextQty) {
    return cartRenderSync.optimisticUpdateQtyTotals(root, qtyBox, previousQty, nextQty);
  }

  function fetchConfigJson(body) {
    return {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    };
  }

  function cartMutation(label, task) {
    if (window.VSKLOCartMutationQueue && typeof window.VSKLOCartMutationQueue.enqueue === 'function') {
      return window.VSKLOCartMutationQueue.enqueue(label, task);
    }
    return Promise.resolve().then(task);
  }

  function queuedFetch(label, url, options) {
    return cartMutation(label, () => fetch(url, options));
  }

  async function commitStructuralRemoval(label, request, staleNode) {
    return cartMutation(label, async () => {
      const res = await request();
      const cart = await res.json();

      if (!res.ok || cart.errors) {
        throw new Error(cart.errors || cart.description || 'Cart remove failed');
      }

      // After the server accepts deletion, leave up to 280 ms for the CSS
      // glass-crack effect before replacing this already-removed line's HTML.
      if (staleNode?.classList?.contains('vsklo-glass-breaking') &&
          !window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches) {
        const elapsed = Date.now() - Number(staleNode.dataset.vskloGlassStartedAt || 0);
        const remaining = Math.max(0, 280 - elapsed);
        if (remaining) await new Promise(resolve => window.setTimeout(resolve, remaining));
      }

      // A promo may re-key or split identical product lines while deleting one.
      // Never remove the current cards or reconcile by stale exact keys before
      // the authoritative Shopify section arrives: this can empty the UI while
      // cart.js still contains a paid item.
      publishCartState(cart);
      updateBadges(cart);
      root.setAttribute('aria-busy', 'true');
      try {
        await refreshCartPageSectionFromServer();
      } catch (refreshError) {
        console.warn('[VSKLO] structural removal needs authoritative page reload', refreshError);
        // Server writes have already committed. Full reload is safer than an
        // incomplete UI based on keys that were invalidated by discounts.
        window.location.reload();
      } finally {
        root.removeAttribute('aria-busy');
      }

      return cart;
    });
  }

  function itemRole(item) {
    return item?.properties?._vsklo_role || item?.properties?.['_vsklo_role'] || '';
  }

  function itemGroup(item) {
    return item?.properties?._vsklo_group_id || item?.properties?.['_vsklo_group_id'] || '';
  }

  function isAddon(item) {
    const props = item?.properties || {};
    return itemRole(item) === 'addon' || props._vsklo_addon === 'service' || props._vsklo_service_type || props._vsklo_service_title || props['Послуга'] || item.product_type === 'Additional option';
  }

  const addonEditor = window.VSKLOCartAddonEditor?.create?.({
    root,
    t: vskloCartT,
  });
  if (!addonEditor) {
    throw new Error('[VSKLO] cart addon editor runtime is missing');
  }

  const splitAddonText = addonEditor.splitAddonText;
  const composeAddonText = addonEditor.composeAddonText;
  const collectEditorText = addonEditor.collectEditorText;
  const autoSizeAddonTextarea = addonEditor.autoSizeAddonTextarea;
  const renderAddonEditor = addonEditor.renderAddonEditor;

  function collectAddonTextForCartPopup(addon) {
    if (!addon || isNoEngravingAddon(addon)) return '';

    const editor = addon.querySelector('[data-vsklo-engraving-editor]');
    const source = addon.querySelector('[data-vsklo-addon-text], .vsklo-cart-popup-addon-text, .product-addons-popup__addon-input, .addon-text');
    let text = '';

    if (editor) text = collectEditorText(editor);

    if (!text) {
      const fields = Array.from(addon.querySelectorAll([
        '[data-vsklo-same-text-field]',
        '[data-vsklo-text-part]',
        '.vsklo-addon-text',
        '.vsklo-cart-popup-addon-text',
        '.vsklo-engraving-generated-field',
        '.vsklo-engraving-textarea',
        '.vsklo-mobile-sms-textarea',
        '.product-addons-popup__addon-input',
        '.addon-text',
        'textarea'
      ].join(','))).filter((field) => {
        if (!field || field.closest('.product-addons-popup__addon-file-wrap')) return false;
        if (field.matches && field.matches('[data-vsklo-addon-text]') && editor) return false;
        return typeof field.value !== 'undefined';
      });

      const values = fields
        .map((field) => String(field.value || '').trim())
        .filter(Boolean);

      if (values.length > 1) text = composeAddonText(values);
      else if (values.length === 1) text = values[0];
    }

    text = String(text || '').trim();

    if (source && source.value !== text) {
      source.value = text;
      try { source.dispatchEvent(new Event('input', { bubbles: true })); } catch (error) {}
      try { source.dispatchEvent(new Event('change', { bubbles: true })); } catch (error) {}
    }

    return text;
  }

  function hydrateCartPage(scope) {
    addonEditor.hydrate(scope);
  }

  function renderAllEngravingEditors() {
    hydrateCartPage(root);
  }

  // Shopify's cart route can return the cart JSON payload to ?sections=...
  // rather than Section Rendering HTML. The supported single-section route
  // reliably returns the cart's Liquid markup in the SAME theme/market locale.
  function cartSectionPreviewUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete('sections');
    url.searchParams.delete('section_id');
    url.searchParams.set('section_id', 'main-cart-items');
    url.hash = '';
    return url.toString();
  }

  async function requestCartSectionHtml() {
    const response = await fetch(cartSectionPreviewUrl(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'text/html' },
    });
    if (!response.ok) throw new Error('Cart section HTML fetch failed: ' + response.status);
    const html = await response.text();
    if (!html.includes('id="main-cart-items"')) throw new Error('Cart section HTML response is missing main-cart-items');
    return html;
  }

  async function refreshCartPageSectionFromServer() {
    const [sectionHtml, cartResponse] = await Promise.all([
      requestCartSectionHtml(),
      fetch(vskloCartRoute('cart.js'), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      }),
    ]);
    if (!cartResponse.ok) {
      throw new Error('Cart state refresh failed: ' + cartResponse.status);
    }

    const cart = await cartResponse.json();
    if (!cart || !Array.isArray(cart.items)) {
      throw new Error('Cart state is invalid after service update');
    }

    const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const freshRoot = parsed.querySelector('#main-cart-items');
    if (!freshRoot) throw new Error('Cart section root is missing');

    root.className = freshRoot.className;
    root.innerHTML = freshRoot.innerHTML;

    updateBadges(cart);
    publishCartState(cart);
    document.dispatchEvent(new CustomEvent('vsklo:content-updated', {
      detail: { scope: root, source: 'cart-service-refresh' },
    }));
    return cart;
  }

  window.VSKLORefreshCartPageFromServer = refreshCartPageSectionFromServer;

  let discountPriceSyncRevision = 0;
  async function refreshCartPriceBlocks() {
    const revision = ++discountPriceSyncRevision;
    const html = await requestCartSectionHtml();
    if (revision !== discountPriceSyncRevision) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const freshRoot = parsed.querySelector('#main-cart-items');
    if (!freshRoot) throw new Error('Cart price section root is missing');

    const freshPrices = new Map();
    freshRoot.querySelectorAll('[data-vsklo-parent-card]').forEach(card => {
      const key = String(card.dataset.cartKey || '');
      const price = card.querySelector(':scope > .vsklo-cart-card-main .vsklo-cart-unit-price');
      if (key && price) freshPrices.set(key, price.innerHTML);
    });

    const currentCards = Array.from(root.querySelectorAll('[data-vsklo-parent-card]'));
    const currentKeys = currentCards.map(card => String(card.dataset.cartKey || ''));
    // If a discount splits or rekeys lines between cart/update.js and the
    // section GET, never attach prices to stale rows.
    if (currentKeys.length !== freshPrices.size || currentKeys.some(key => !freshPrices.has(key))) {
      await refreshCartPageSectionFromServer();
      return;
    }

    currentCards.forEach(card => {
      const key = String(card.dataset.cartKey || '');
      const price = card.querySelector(':scope > .vsklo-cart-card-main .vsklo-cart-unit-price');
      if (!price) return;
      const freshMarkup = freshPrices.get(key);
      // Includes new/removing sale badges and discount allocation labels,
      // not just the unit's number. No page reload is required.
      if (price.innerHTML !== freshMarkup) price.innerHTML = freshMarkup;
    });
  }

  function updateBadges(cart) {
    return cartRenderSync.updateBadges(root, cart);
  }

  function publishCartState(cart) {
    return cartRenderSync.publishCartState(cart);
  }

  function updateCartDomFromState(cart) {
    return cartRenderSync.updateCartDomFromState(root, cart, {
      isAddon,
      itemGroup,
      renderAddonEditor,
    });
  }

  const addonServiceRuntime = window.VSKLOCartAddonService;
  if (!addonServiceRuntime || typeof addonServiceRuntime.create !== 'function') {
    throw new Error('[VSKLO] cart addon service runtime is missing');
  }

  const getAddonServiceType = addonServiceRuntime.getAddonServiceType;
  const isNoEngravingAddon = addonServiceRuntime.isNoEngravingAddon;
  const getRequiredTextMessage = (addon) => addonServiceRuntime.getRequiredTextMessage(addon, vskloCartT);

  let cartCore = null;
  let popupUI = null;

  const addonService = addonServiceRuntime.create({
    root,
    route: vskloCartRoute,
    fetchConfigJson,
    cartMutation,
    updateCartDomFromState,
    collectAddonText: collectAddonTextForCartPopup,
    splitAddonText,
    itemGroup,
    isAddon,
    t: vskloCartT,
    message: vskloCartMessage,
    refreshCartPage: refreshCartPageSectionFromServer,
    getCartCore: () => cartCore,
    getPopupUI: () => popupUI,
  });
  if (!addonService) {
    throw new Error('[VSKLO] cart addon service controller failed to initialize');
  }

  const saveAddonText = addonService.saveAddonText;
  const addServicesToExistingProduct = addonService.addServicesToExistingProduct;

  popupUI = window.VSKLOCartPopupUI?.create?.({
    formatMoney,
    isNoEngravingAddon,
    getRequiredTextMessage,
    collectAddonText: collectAddonTextForCartPopup,
  });
  if (!popupUI) {
    throw new Error('[VSKLO] cart popup UI runtime is missing');
  }

  const isCartAddonMobile = popupUI.isCartAddonMobile;
  const isCartPopupTextAddon = popupUI.isCartPopupTextAddon;
  const syncCartPopupTextFields = popupUI.syncCartPopupTextFields;
  const clearCartPopupTextInlineStyles = popupUI.clearCartPopupTextInlineStyles;
  const ensureCartMobileTextControls = popupUI.ensureCartMobileTextControls;
  const refreshCartMobileTextControls = popupUI.refreshCartMobileTextControls;
  const handleCartMobileTextAction = popupUI.handleCartMobileTextAction;
  const resetPopup = popupUI.resetPopup;
  const focusCartAddonDialog = popupUI.focusCartAddonDialog;
  const closePopup = popupUI.closePopup;
  const updatePopupTotal = popupUI.updatePopupTotal;
  const clearAddonInlineError = popupUI.clearAddonInlineError;

  cartCore = window.VSKLOCartCore?.create?.({
    root,
    isAddon,
    itemGroup,
    route: vskloCartRoute,
    fetchConfigJson,
    queuedFetch,
    cartMutation,
    updateCartDomFromState,
    refreshPriceBlocks: refreshCartPriceBlocks,
    refreshCartPage: refreshCartPageSectionFromServer,
    publishCartState,
    saveAddonText,
    message: vskloCartMessage,
    t: vskloCartT,
  });
  if (!cartCore) {
    throw new Error('[VSKLO] cart core runtime is missing');
  }

  function updateQtyUI(qtyBox, nextQty) {
    const input = qtyBox.querySelector('[data-vsklo-qty-input]');
    if (!input) return;
    const previousQty = Math.max(0, parseInt(input.dataset.value || input.value || '0', 10) || 0);
    nextQty = Math.max(0, parseInt(nextQty ?? 1, 10));
    optimisticUpdateQtyTotals(qtyBox, previousQty, nextQty);
    input.value = nextQty;
    input.dataset.value = String(nextQty);
    const holder = qtyBox.closest('[data-vsklo-parent-card], [data-vsklo-addon-row], [data-vsklo-orphan]');
    if (holder?.matches?.('[data-vsklo-addon-row]') && nextQty > 0) renderAddonEditor(holder, nextQty);
    if (holder?.matches?.('[data-vsklo-parent-card]') && qtyBox.closest('.vsklo-cart-card-main')) {
      const popupSubmit = holder.querySelector('[data-vsklo-cart-addon-popup] .js-vsklo-cart-addons-submit');
      if (popupSubmit) popupSubmit.dataset.parentQuantity = String(Math.max(1, nextQty));

      const delta = nextQty - previousQty;
      if (delta) {
        holder.querySelectorAll('[data-vsklo-addon-row]').forEach((row) => {
          const childQty = row.querySelector('[data-vsklo-qty]');
          const childInput = childQty?.querySelector('[data-vsklo-qty-input]');
          if (!childQty || !childInput) return;

          const currentChildQty = Math.max(0, parseInt(childInput.value || '0', 10) || 0);
          const nextChildQty = Math.max(0, currentChildQty + delta);
          if (currentChildQty !== nextChildQty) updateQtyUI(childQty, nextChildQty);
        });
      }
    }
    cartCore.queueQuantity(qtyBox.dataset.key, nextQty, holder);
  }
document.addEventListener('click', async (event) => {
    const blockedDuringClear = event.target.closest('[data-vsklo-qty-minus], [data-vsklo-qty-plus], [data-vsklo-remove-parent], [data-vsklo-remove-addon], [data-vsklo-open-cart-addons], [data-vsklo-save-addon]');
    if (cartCore.isClearing() && blockedDuringClear) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      return;
    }

    const clearCartButton = event.target.closest('#main-cart-items [data-vsklo-clear-cart]');
    if (clearCartButton) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      if (!clearCartButton.classList.contains('is-loading')) await clearWholeCart(clearCartButton);
      return;
    }

    const minus = event.target.closest('[data-vsklo-qty-minus]');
    const plus = event.target.closest('[data-vsklo-qty-plus]');
    if (minus || plus) {
      event.preventDefault();
      const qtyBox = event.target.closest('[data-vsklo-qty]');
      const input = qtyBox?.querySelector('[data-vsklo-qty-input]');
      if (!qtyBox || !input) return;
      const parsedCurrent = parseInt(input.value || '1', 10);
      const current = Number.isFinite(parsedCurrent) ? parsedCurrent : 1;
      const next = plus ? current + 1 : current - 1;
      if (next <= 0) {
        const parentCard = qtyBox.closest('[data-vsklo-parent-card]');
        const addonRow = qtyBox.closest('[data-vsklo-addon-row], [data-vsklo-orphan]');
        if (parentCard && qtyBox.closest('.vsklo-cart-card-main')) {
          parentCard.querySelector('[data-vsklo-remove-parent]')?.click();
        } else if (addonRow) {
          addonRow.querySelector('[data-vsklo-remove-addon]')?.click();
        }
        return;
      }
      updateQtyUI(qtyBox, next);
      return;
    }

    const removeParent = event.target.closest('[data-vsklo-remove-parent]');
    if (removeParent) {
      event.preventDefault();
      const card = removeParent.closest('[data-vsklo-parent-card]');
      if (!card || card.dataset.vskloStructuralBusy === '1') return;
      card.dataset.vskloStructuralBusy = '1';
      card.dataset.vskloGlassStartedAt = String(Date.now());
      card.classList.add('is-updating', 'vsklo-glass-breaking');
      try {
        await cartCore.prepareStructuralRemoval(card);
        let resolvedParentKey = '';
        // Resolve-and-remove as one queued mutation: changing service properties
        // re-keys parent lines and must not interleave with their deletion.
        const removedCart = await commitStructuralRemoval('remove-parent-group', async () => {
          const latestResponse = await fetch(vskloCartRoute('cart.js'), {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' },
          });
          if (!latestResponse.ok) throw new Error('Could not read current cart before parent removal');
          const latestCart = await latestResponse.json();
          if (!Array.isArray(latestCart.items)) throw new Error('Invalid cart state before parent removal');

          const currentKey = String(card.dataset.cartKey || '');
          const variantId = Number(card.dataset.variantId || 0);
          const groupId = String(card.dataset.vskloGroupId || '');
          let parentItem = latestCart.items.find((item) => item.key === currentKey && !isAddon(item));
          if (!parentItem && groupId) {
            const matches = latestCart.items.filter((item) =>
              !isAddon(item) &&
              Number(item.variant_id) === variantId &&
              String(itemGroup(item)) === groupId
            );
            if (matches.length === 1) parentItem = matches[0];
          }
          if (!parentItem && variantId) {
            const sameVariant = latestCart.items.filter((item) =>
              !isAddon(item) && Number(item.variant_id) === variantId
            );
            if (sameVariant.length === 1) parentItem = sameVariant[0];
          }
          if (!parentItem) throw new Error('Parent cart line changed or is ambiguous; refusing to remove another product');

          resolvedParentKey = parentItem.key;
          const resolvedGroup = String(itemGroup(parentItem) || groupId);
          const updates = { [resolvedParentKey]: 0 };
          if (resolvedGroup) {
            // Discount-split siblings share a group ID; deleting one row must
            // never silently discard the services of surviving rows.
            const survivingParents = latestCart.items.filter((item) =>
              !isAddon(item) && item.key !== resolvedParentKey &&
              String(itemGroup(item)) === resolvedGroup
            );
            if (!survivingParents.length) {
              latestCart.items.forEach((item) => {
                if (isAddon(item) && String(itemGroup(item)) === resolvedGroup) {
                  updates[item.key] = 0;
                }
              });

            }
          }
          return fetch(vskloCartRoute('cart/update.js'), fetchConfigJson({ updates }));
        }, card);
        if (removedCart?.items?.some((item) => item.key === resolvedParentKey)) {
          throw new Error('Shopify did not remove the resolved parent cart line');
        }
      } catch (error) {
        console.error('VSKLO parent remove failed', error);
        if (error?.vskloCartValidation) {
          vskloCartMessage(error.message);
          card.classList.remove('is-updating', 'vsklo-glass-breaking');
        } else {
          window.location.reload();
        }
      } finally {
        if (card?.dataset) delete card.dataset.vskloStructuralBusy;
      }
      return;
    }

    const removeAddon = event.target.closest('[data-vsklo-remove-addon]');
    if (removeAddon) {
      event.preventDefault();
      const row = removeAddon.closest('[data-vsklo-addon-row], [data-vsklo-orphan]');
      if (!row || row.dataset.vskloStructuralBusy === '1') return;
      row.dataset.vskloStructuralBusy = '1';
      row.dataset.vskloGlassStartedAt = String(Date.now());
      row.classList.add('is-updating', 'vsklo-glass-breaking');
      try {
        await cartCore.prepareStructuralRemoval(row);
        // Discounts and personalization can change a service line key after
        // the button was rendered. Resolve it inside the serialized mutation,
        // otherwise Shopify may accept a stale key without removing the line.
        await commitStructuralRemoval('remove-addon', async () => {
          const latestResponse = await fetch(vskloCartRoute('cart.js'), {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' },
          });
          if (!latestResponse.ok) throw new Error('Could not read current cart before service removal');
          const latestCart = await latestResponse.json();
          const currentKey = String(row.dataset.cartKey || '');
          const variantId = Number(row.dataset.variantId || 0);
          const groupId = String(row.dataset.vskloGroupId || '');
          let serviceItem = latestCart.items.find((item) => item.key === currentKey && isAddon(item));
          if (!serviceItem && variantId) {
            const matches = latestCart.items.filter((item) =>
              isAddon(item) &&
              Number(item.variant_id) === variantId &&
              String(itemGroup(item) || '') === groupId
            );
            if (matches.length === 1) serviceItem = matches[0];
          }
          if (!serviceItem) {
            throw new Error('Service cart key changed or is ambiguous; refusing to remove a different service');
          }
          const response = await fetch(
            vskloCartRoute('cart/update.js'),
            fetchConfigJson({ updates: { [serviceItem.key]: 0 } })
          );
          return response;
        }, row);
      } catch (error) {
        console.error('VSKLO addon remove failed', error);
        window.location.reload();
      } finally {
        if (row?.dataset) delete row.dataset.vskloStructuralBusy;
      }
      return;
    }

    const saveAddon = event.target.closest('[data-vsklo-save-addon]');
    if (saveAddon) {
      event.preventDefault();
      await saveAddonText(saveAddon.closest('[data-vsklo-addon-row]'));
      return;
    }

    const openCartAddons = event.target.closest('[data-vsklo-open-cart-addons]');
    if (openCartAddons) {
      event.preventDefault();
      event.stopPropagation();

      if (openCartAddons.dataset.vskloOpening === '1') return;

      const addonRuntimePromise = typeof window.VSKLOEnsureCartAddonV3 === 'function'
        ? window.VSKLOEnsureCartAddonV3()
        : Promise.resolve(window.VSKLOAddonV3 || null);

      const parentCard = openCartAddons.closest('[data-vsklo-parent-card]');
      if (!parentCard) return;

      openCartAddons.dataset.vskloOpening = '1';
      let popup = null;

      try {
        const parentProductHandle = String(parentCard.dataset.vskloProductHandle || '').trim();
        const belongsToParentProduct = (node) => {
          if (!node) return false;
          const popupProductHandle = String(node.dataset.vskloParentProductHandle || '').trim();
          return !parentProductHandle || popupProductHandle === parentProductHandle;
        };

        popup = parentCard.querySelector('[data-vsklo-cart-addon-popup]');
        if (popup && !belongsToParentProduct(popup)) popup = null;

        // If the popup was already moved to <body>, find it by the current cart
        // key AND the same source product. Never reuse another parent's addon list.
        if (!popup && parentCard.dataset.cartKey) {
          popup = Array.from(document.querySelectorAll('[data-vsklo-cart-addon-popup]')).find((node) => {
            return belongsToParentProduct(node) &&
              node.dataset.vskloParentKey === parentCard.dataset.cartKey;
          }) || null;
        }

        // Recovery for a stale body-level popup after a cart-key/property rewrite.
        // Product handle is the immutable source identity; group/variant are only
        // secondary locators inside that product's own popup candidates.
        if (!popup) {
          const groupId = String(parentCard.dataset.vskloGroupId || '').trim();
          const variantId = String(parentCard.dataset.variantId || '').trim();
          const bodyCandidates = Array.from(
            document.querySelectorAll('body > [data-vsklo-cart-addon-popup]')
          ).filter(belongsToParentProduct);

          if (groupId) {
            popup = bodyCandidates.find((node) => {
              return node.querySelector('.js-vsklo-cart-addons-submit')?.dataset.parentGroup === groupId;
            }) || null;
          }
          if (!popup && variantId) {
            const variantCandidates = bodyCandidates.filter((node) => {
              return String(node.querySelector('.js-vsklo-cart-addons-submit')?.dataset.parentVariantId || '') === variantId;
            });
            if (variantCandidates.length === 1) popup = variantCandidates[0];
          }
        }

        if (!popup) {
          console.warn('VSKLO cart add-on popup not found for cart line', parentCard.dataset.cartKey || '');
          return;
        }

        const parentKey = String(parentCard.dataset.cartKey || '').trim();
        if (parentKey) {
          document.querySelectorAll('[data-vsklo-cart-addon-popup]').forEach((node) => {
            if (
              node !== popup &&
              node.dataset.vskloParentKey === parentKey &&
              node.parentElement === document.body
            ) {
              node.remove();
            }
          });
          popup.dataset.vskloParentKey = parentKey;
        }

        const parentQty = parentCard.querySelector('[data-vsklo-parent-qty]')?.value || parentCard.querySelector('[data-vsklo-qty] input, input[name="updates[]"]')?.value || '1';
        const submitButton = popup.querySelector('.js-vsklo-cart-addons-submit');
        if (submitButton) submitButton.dataset.parentQuantity = String(Math.max(1, parseInt(parentQty, 10) || 1));

        // Re-bind the popup to the CURRENT cart card on every open. Cart line keys
        // and DOM nodes can change after an Ajax quantity/property update.
        popup.__vskloReturnParent = openCartAddons.parentNode;
        popup.__vskloReturnNextSibling = openCartAddons.nextSibling;

        document.querySelectorAll('[data-vsklo-cart-addon-popup].is-active').forEach((node) => {
          if (node !== popup) closePopup(node);
        });

        if (popup.parentElement !== document.body) {
          document.body.appendChild(popup);
        }

        // Cart dialogs must be truly inert while closed. The shared mobile V3
        // layout contains descendants with pointer-events:auto, so relying only
        // on opacity/visibility can leave an invisible hit layer over the cart.
        window.clearTimeout(popup.__vskloHideTimer);
        popup.hidden = false;
        popup.removeAttribute('inert');

        resetPopup(popup);

        try {
          await addonRuntimePromise;
        } catch (addonRuntimeLoadError) {
          console.error('VSKLO cart add-on V3 runtime load failed; opening base dialog', addonRuntimeLoadError);
        }

        /*
         * The shared V3 UI is progressive enhancement for the cart dialog.
         * A renderer error must never permanently lock the "Add service" button.
         */
        try {
          if (window.VSKLOAddonV3 && typeof window.VSKLOAddonV3.init === 'function') {
            window.VSKLOAddonV3.init(popup);
          }
          if (window.VSKLOAddonV3 && typeof window.VSKLOAddonV3.refresh === 'function') {
            window.VSKLOAddonV3.refresh(popup);
          }
        } catch (addonUiError) {
          console.error('VSKLO cart add-on V3 init failed; opening base dialog', addonUiError);
        }

        popup.__vskloOpener = openCartAddons;
        popup.classList.add('is-active');
        popup.setAttribute('aria-hidden', 'false');
        if (window.VSKLOOverlayState) window.VSKLOOverlayState.acquire('cart-addon');
        else document.documentElement.classList.add('open-popup');
        updatePopupTotal(popup);
        if (!popup.hasAttribute('data-vsklo-addon-v3')) {
          refreshCartMobileTextControls(popup);
        }
        focusCartAddonDialog(popup);
      } catch (error) {
        console.error('VSKLO cart add-on popup open failed', error);
        vskloCartMessage(vskloCartT('addServiceError', 'Не вдалося відкрити додаткові послуги. Спробуйте ще раз.'));
      } finally {
        // Never leave the trigger in a dead "opening" state. This was the reason
        // a page reload could appear to "fix" an otherwise dead button.
        delete openCartAddons.dataset.vskloOpening;
      }
      return;
    }

    const cartMobileTextAction = event.target.closest('.vsklo-cart-addon-popup [data-vsklo-mobile-confirm-text], .vsklo-cart-addon-popup [data-vsklo-mobile-cancel-text], .vsklo-cart-addon-popup [data-vsklo-mobile-edit-text]');
    if (cartMobileTextAction) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      handleCartMobileTextAction(cartMobileTextAction);
      return;
    }

    const cartAddonCard = event.target.closest('.vsklo-cart-addon-popup .product-addons-popup__addon');
    const cartAddonPopupForCard = cartAddonCard?.closest('[data-vsklo-cart-addon-popup]');
    const sharedAddonUiReady = cartAddonPopupForCard?.dataset.vskloRedesignReady === 'true';
    if (cartAddonCard && !sharedAddonUiReady) {
      const isInteractive = event.target.closest('input, textarea, select, button, a, label, .product-addons-popup__addon-file-wrap, .product-addons-popup__addon-file-remove');
      if (!isInteractive) {
        event.preventDefault();
        const checkbox = cartAddonCard.querySelector('.product-addons-popup__addon-checkbox');
        if (checkbox && !checkbox.disabled) {
          checkbox.checked = !checkbox.checked;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
    }

    const closeCartAddons = event.target.closest('[data-vsklo-close-cart-addons]');
    if (closeCartAddons) {
      event.preventDefault();
      closePopup(closeCartAddons.closest('[data-vsklo-cart-addon-popup]'));
      return;
    }

    const cancelCartAddons = event.target.closest('[data-vsklo-cart-addons-cancel]');
    if (cancelCartAddons) {
      event.preventDefault();
      const popup = cancelCartAddons.closest('[data-vsklo-cart-addon-popup]');
      resetPopup(popup);
      closePopup(popup);
      return;
    }

    const submitCartAddons = event.target.closest('.js-vsklo-cart-addons-submit');
    if (submitCartAddons) {
      event.preventDefault();
      event.stopPropagation();
      if (submitCartAddons.dataset.vskloSubmitting === '1') return;
      await addServicesToExistingProduct(submitCartAddons.closest('[data-vsklo-cart-addon-popup]'), submitCartAddons);
      return;
    }
  });

  document.addEventListener('input', (event) => {
    const field = event.target.closest('[data-vsklo-same-text-field], [data-vsklo-text-part]');
    if (!field) return;
    autoSizeAddonTextarea(field);
    const editor = field.closest('[data-vsklo-engraving-editor]');
    const source = editor?.querySelector('[data-vsklo-addon-text]');
    if (editor && source) source.value = collectEditorText(editor);
    const row = field.closest('[data-vsklo-addon-row]');
    if (row) {
      row.dataset.vskloDirty = '1';
      setAutosaveStatus(row, vskloCartT('changesNotSaved', 'Зміни не збережено'));
    }
  });

  document.addEventListener('focusout', (event) => {
    const field = event.target.closest('[data-vsklo-same-text-field], [data-vsklo-text-part]');
    if (!field) return;
    const row = field.closest('[data-vsklo-addon-row]');
    if (row) cartCore.scheduleAddonAutosave(row, 350);
  });

  document.addEventListener('change', (event) => {
    const sameTextCheckbox = event.target.closest('[data-vsklo-same-text]');
    if (sameTextCheckbox) {
      const row = sameTextCheckbox.closest('[data-vsklo-addon-row]');
      renderAddonEditor(row, row?.querySelector('[data-vsklo-qty-input]')?.value || 1, sameTextCheckbox.checked);
      if (row) row.dataset.vskloDirty = '1';
      cartCore.scheduleAddonAutosave(row, 500);
      return;
    }

    const input = event.target.closest('[data-vsklo-qty-input]');
    if (input) {
      const qtyBox = input.closest('[data-vsklo-qty]');
      const nextQty = Math.max(0, parseInt(input.value || '0', 10) || 0);
      if (nextQty <= 0) {
        const parentCard = qtyBox?.closest('[data-vsklo-parent-card]');
        const addonRow = qtyBox?.closest('[data-vsklo-addon-row], [data-vsklo-orphan]');
        if (parentCard && qtyBox.closest('.vsklo-cart-card-main')) {
          parentCard.querySelector('[data-vsklo-remove-parent]')?.click();
        } else if (addonRow) {
          addonRow.querySelector('[data-vsklo-remove-addon]')?.click();
        }
        return;
      }
      updateQtyUI(qtyBox, nextQty);
      return;
    }


    const checkbox = event.target.closest('.vsklo-cart-addon-popup .product-addons-popup__addon-checkbox');
    if (checkbox) {
      const addon = checkbox.closest('.product-addons-popup__addon');
      const popup = checkbox.closest('[data-vsklo-cart-addon-popup]');
      addon?.classList.toggle('is-active', checkbox.checked);

      if (addon && isCartPopupTextAddon(addon) && !popup?.hasAttribute('data-vsklo-addon-v3')) {
        if (checkbox.checked && isCartAddonMobile()) {
          clearCartPopupTextInlineStyles(addon);
          ensureCartMobileTextControls(addon);
          if (!addon.classList.contains('vsklo-mobile-text-confirmed') && !addon.classList.contains('vsklo-mobile-text-collapsed')) {
            addon.classList.add('vsklo-mobile-text-open');
          }
        } else if (!checkbox.checked) {
          syncCartPopupTextFields(addon, '');
          clearAddonInlineError(addon);
          addon.classList.remove('vsklo-mobile-text-open', 'vsklo-mobile-text-confirmed', 'vsklo-mobile-text-collapsed', 'vsklo-addon-error');
          addon.removeAttribute('data-vsklo-mobile-text-confirmed');
          clearCartPopupTextInlineStyles(addon);
        }
      }

      updatePopupTotal(popup);
    }
  });


  document.addEventListener('input', (event) => {
    const addon = event.target?.closest?.('.product-addons-popup__addon');
    if (addon) clearAddonInlineError(addon);
  }, true);

  document.addEventListener('change', (event) => {
    const addon = event.target?.closest?.('.product-addons-popup__addon');
    if (addon) clearAddonInlineError(addon);
  }, true);

  window.VSKLOHydrateCartPage = hydrateCartPage;
  if (window.VSKLOHydration && typeof window.VSKLOHydration.register === 'function') {
    window.VSKLOHydration.register('cart-page', hydrateCartPage);
  } else {
    document.addEventListener('vsklo:content-updated', (event) => {
      hydrateCartPage(event?.detail?.scope || event?.target || root);
    });
  }

  window.addEventListener('pageshow', (event) => {
    if (!event || !event.persisted) return;
    document.querySelectorAll('[data-vsklo-cart-addon-popup].is-active').forEach((popup) => {
      closePopup(popup);
    });
    hydrateCartPage(root);
  });

  // Repair only explicit schema-v2 linked services whose original parent has
  // disappeared from this cart. Do not touch independent products or legacy
  // services: the customer must never pay for a gift bag tied to a removed item.
  let orphanCleanupPending = null;

  function orphanLinkedServices(items) {
    const lines = Array.isArray(items) ? items : [];
    const physical = lines.filter((item) => !isAddon(item));
    return lines.filter((item) => {
      const props = item && item.properties || {};
      if (String(props._vsklo_role || '') !== 'addon' ||
          String(props._vsklo_schema_version || '') !== '2') return false;
      const group = String(props._vsklo_group_id || '').trim();
      const parentVariant = String(props._vsklo_parent_variant_id || '').trim();
      if (!group || !parentVariant) return true;
      return !physical.some((parent) =>
        String(itemGroup(parent) || '') === group &&
        String(parent.variant_id || parent.id || '') === parentVariant
      );
    });
  }

  async function repairOrphanServices() {
    if (orphanCleanupPending) return orphanCleanupPending;
    orphanCleanupPending = cartMutation('repair-orphan-schema-v2-services', async () => {
      const read = async () => {
        const response = await fetch(vskloCartRoute('cart.js'), {
          credentials: 'same-origin', cache: 'no-store',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error('Unable to read current Shopify cart');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error('Invalid Shopify cart response');
        return cart;
      };
      const snapshot = await read();
      const orphans = orphanLinkedServices(snapshot.items);
      if (!orphans.length) return { removed: 0 };
      const updates = {};
      orphans.forEach((item) => {
        if (!item.key) throw new Error('Cannot safely identify orphan cart line');
        updates[item.key] = 0;
      });
      const response = await fetch(vskloCartRoute('cart/update.js'), fetchConfigJson({ updates }));
      const result = await response.json();
      if (!response.ok || result.errors) {
        throw new Error(result.errors || result.description || 'Could not remove orphan services');
      }
      const verified = await read();
      if (orphanLinkedServices(verified.items).length) {
        throw new Error('Orphan service removal has not been verified in Shopify');
      }
      window.__VSKLO_ORPHAN_CART_RELOAD_PENDING__ = true;
      vskloCartMessage(vskloCartText('cart', 'orphanRemoved',
        'Зайву послугу без основного товару видалено. Кошик оновлено.'));
      window.location.reload();
      return { removed: orphans.length };
    });
    try {
      return await orphanCleanupPending;
    } finally {
      orphanCleanupPending = null;
    }
  }

  window.VSKLOCartOrphanCleanup = repairOrphanServices;
  renderAllEngravingEditors();
  // Resolve stale sessions and cart links on entry, before either V1 or V2 CRM
  // can receive a Chekly order with an orphaned schema-v2 add-on.
  repairOrphanServices().catch((error) => {
    console.warn('[VSKLO] orphan cart service repair unavailable; checkout must remain guarded', error);
  });
})();
